<template>
  <VueApexCharts type="bar" height="300" :options="chartOptions" :series="series"></VueApexCharts>
</template>

<script>

import VueApexCharts from 'vue-apexcharts'

export default {
  components: {
    VueApexCharts
  },
  props: {
    chartInput: Object
  },
  watch: {
    chartInput () {
      this.loadSubFactorChart()
    }
  },
  data () {
    return {
      series: [],
      chartOptions: {
        colors: ['#6381c5', '#28C76F', '#EA5455', '#FF9F43', '#1E1E1E'],
        chart: {
          type: 'bar'
        },
        plotOptions: {
          animations: {
            enabled: false
          },
          bar: {
            columnWidth: '80%',
            dataLabels: {
              position: 'bottom' // top, center, bottom
            },
            colors: {
              ranges: [
                {
                  from: 0,
                  to: 0,
                  color: ['#6381c5', '#28C76F', '#EA5455', '#FF9F43', '#1E1E1E']
                }
              ],
              backgroundBarColors: [],
              backgroundBarOpacity: 1,
              backgroundBarRadius: 0
            }
          }
        },
        fill: {
          opacity: [0.85, 0.25, 1],
          gradient: {
            inverseColors: false,
            shade: 'light',
            type: 'vertical',
            opacityFrom: 0.85,
            opacityTo: 0.55,
            stops: [0, 100, 100, 100]
          }
        },
        labels: ['AAA', 'AA', 'A', 'BBB', 'BB', 'B', 'CCC', 'CC'],
        dataLabels: {
          enabled: false,
          formatter (val) {
            return val
          },
          offsetY: -20,
          style: {
            fontSize: '12px',
            colors: ['#6381c5']
          }
        },
        xaxis: {
          categories: []
        },
        yaxis: {
          title: {
            text: 'Total'
          },
          min: 0
        }
      }
    }
  },
  methods: {
    loadSubFactorChart () {
      this.series.pop()
      this.series.push(this.chartInput)
      this.chartOptions = {
        xaxis: {
          categories: this.chartInput.categories
        }
      }
    }
  }
}

</script>
